import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
// import { CnpjService } from 'src/services/cnpj.service';
import { HttpService } from 'src/services/http.service';

@Component({
  selector: 'app-register-company',
  templateUrl: './register-company.component.html',
  styleUrls: ['./register-company.component.scss']
})
export class RegisterCompanyComponent implements OnInit {

  stepsValid: boolean[] = [false, false, false];
  @ViewChild(MatStepper) stepper: MatStepper;
  isLinearSteep: boolean = true;
  isSmallScreen$: Observable<boolean>;
  hiddenCheckout: boolean = false;
  stepOne: UntypedFormGroup;
  stepTwo: UntypedFormGroup;
  stepThree: UntypedFormGroup;
  isFree: boolean = false;
  continueDataEvent: EventEmitter<any> = new EventEmitter<any>();
  continueRegister: boolean = false;

  constructor(
    private breakpoint: BreakpointObserver,
    private change: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
    // private cnpj: CnpjService,
    private http: HttpService
  ) {

    // if (this.route.snapshot.queryParams.free) {
    //   this.isFree = true;
    //   this.stepsValid[2] = true;
    // }

    // this.stepsValid[0] = true;
    // this.stepsValid[1] = true;

  }

  ngOnInit(): void {

    this.isSmallScreen$ = this.breakpoint
      .observe([Breakpoints.XSmall, Breakpoints.HandsetPortrait])
      .pipe(
        map(state => state.matches)
      )

    if (this.route.snapshot.queryParams.cnpj) {
      this._getContinueData();
    }

  }

  private _getCompanyFromCampaign() {

    const data = {
      cnpj: this.route.snapshot.queryParams.cnpj
    };
    this.http.list('company_boleto', data)
      .subscribe(
        (billet: any) => {
          if (billet) {

            const data =
            {
              user: {
                email: billet.Email,
                firstname: billet.Label,
                phone: billet.Telefone
              },
              company: {
                companyname: billet.Label,
                companyemail: billet.Email,
                cnpj: billet.CNPJ,
                tax_regime: null,
                companyzipcode: billet.Cep,
                companystate: billet.UF,
                companycity: billet.Cidade,
                district: billet.Bairro,
                companyaddress1: billet.Endereco,
                companyaddress2: billet.Numero,
                complement: billet.Complemento
              }
            }

            this.continueDataEvent.emit(data);

          }
        },
        err => console.error(err)
      )

  }

  private _getContinueData() {

    const data = {
      cnpj: this.route.snapshot.queryParams.cnpj
    };
    this.http.list('continue_registration', data)
      .subscribe(
        (result: any) => {
          // console.log('APP', result)
          if (Object.keys(result.user).length > 0) {

            this.continueRegister = true;

            const filteredUserData = {}

            for (const key in result['user']) {
              const value = result['user'][key];
              if (value != 'undefined' && value != 'false') {
                filteredUserData[key] = value;
              }
            }

            result['user'] = filteredUserData;
            this.continueDataEvent.emit(result);

          } else this._getCompanyFromCampaign();

        }
      )

  }

  public onHiddenCheckout(hidden: boolean) {

    if (!this.isFree) {
      this.stepsValid[2] = hidden;
      this.hiddenCheckout = hidden;
    }

  }

  public onStepOne(args) {

    this.stepOne = (args as UntypedFormGroup);
    this.change.detectChanges();

  }

  public onStepTwo(args) {

    this.stepTwo = (args as UntypedFormGroup);
    this.change.detectChanges();

  }

  public onStepThree(args) {

    this.stepThree = (args as UntypedFormGroup);
    this.change.detectChanges();

  }

  public isComplete() {
    // console.log(this.stepsValid);
    return this.stepsValid.every(value => value === true);
  }

  public doneAll() {

    if (this.isComplete()) {

      if (!this.isFree) {
        const email = this.stepOne.get('email').value;
        this.makeAccountPaid(email);
      }
      // this.cnpj.updateCnpj(email);      
      alert('Cadastro concluido com sucesso');
      this.router.navigate(['/']);
    }

  }

  public submitStepTwo() {

    this.stepsValid[1] = true;
    this.router.navigate(['/', 'register', 'company'], { queryParams: { ...this.route.snapshot.queryParams, valid: true } });

  }

  private makeAccountPaid(email: string) {

    this.http.save('profile:make_paid', { email })
      .subscribe(
        (result: any) => {

        },
        err => console.error(err)
      )

  }

  handleFinishSubmit(value: boolean) {
    this.stepsValid[2] = true;
    this.isComplete(); 
  }


}
